import { Helper } from '@archistarai/auth-frontend';
import cartRoutes from './routes/cart';
import selfServeRoutes from './routes/self-serve';
import directMailRoutes from './routes/direct-mail';
import adminRoutes from './routes/admin';
import financeRoutes from './routes/finance';
import subscriptionRoutes from './routes/subscription';
import academyRoutes from './routes/academy';
import archistarRoutes from './routes/archistar';

let routes = [
  {
    path: '',
    component: () => import('@/layouts/main/archistar/Main.vue'),
    children: [
      {
        path: '/',
        name: 'homepage',
        component: () => import('@/views/archistar/Homepage.vue'),
        meta: {
          breadcrumb: [{ title: 'Home', url: '/', active: true }],
          pageTitle: 'Home'
        }
      }
    ]
  },
  {
    path: '/login-success',
    name: 'Login Success',
    component: () => import('@/views/archistar/LoginSuccess.vue')
  },
  {
    path: '/invoice/:guid',
    name: 'Invoice',
    component: () => import('@/views/archistar/Invoice.vue')
  },
  {
    path: '/user',
    component: () => import('@/layouts/main/archistar/Main.vue'),
    children: [
      {
        path: 'profile',
        name: 'self-user-profile',
        component: () => import('@/views/archistar/user/Profile.vue'),
        props: {
          scope: 'user'
        },
        meta: {
          breadcrumb: [{ title: 'Home', url: '/' }, { title: 'User' }, { title: 'Profile', active: true }],
          pageTitle: 'My Profile'
        }
      },
      {
        path: 'profile/:guid',
        name: 'user-profile',
        component: () => import('@/views/archistar/user/Profile.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'User'
            },
            {
              title: 'Profile',
              active: true
            }
          ],
          pageTitle: 'User Profile',
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      }
    ]
  },
  {
    path: '/company',
    component: () => import('@/layouts/main/archistar/Main.vue'),
    children: [
      {
        path: 'profile/:guid',
        name: 'company-profile',
        component: () => import('@/views/archistar/user/Profile.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Company'
            },
            {
              title: 'Profile',
              active: true
            }
          ],
          pageTitle: 'Company Profile',
          rules: [
            {
              resource: 'users',
              rule: 'read'
            }
          ]
        }
      }
    ]
  },
  {
    // Redirect to 404 page, if no match found
    path: '*',
    // redirect: '/pages/error-404'
    name: 'page-not-found-404',
    component: () => import('@/views/pages/archistar/Error404.vue'),
    meta: {
      noAuthRequired: true
    }
  }
];

const refactoredRoutes = [
  {
    path: '/archiagent',
    component: () => import('@/layouts/main/archistar/Main.vue'),
    children: [
      {
        path: 'dashboard',
        name: 'archiagent-dashboard',
        component: () => import('@/views/DashboardECommerce.vue'),
        props: {
          scope: 'archiagent.dashboard'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archi-Agent'
            },
            {
              title: 'Dashboard',
              active: true
            }
          ],
          pageTitle: 'Archi-Agent Dashboard'
        }
      },
      {
        path: 'companies',
        name: 'archiagent.companies',
        component: () => import('@/components/archistar/table/table.vue'),
        props: {
          scope: 'archiagent.companies'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archi-Agent'
            },
            {
              title: 'Companies',
              active: true
            }
          ],
          pageTitle: 'Archi-Agent Companies'
        }
      },
      {
        path: 'users',
        name: 'archiagent.users',
        component: () => import('@/components/archistar/table/table.vue'),
        props: {
          scope: 'archiagent.users'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archi-Agent'
            },
            {
              title: 'Users',
              active: true
            }
          ],
          pageTitle: 'Archi-Agent Users'
        }
      }
    ]
  },
  {
    path: '/fengshui',
    component: () => import('@/layouts/main/archistar/Main.vue'),
    children: [
      {
        path: 'dashboard',
        name: 'fengshui-dashboard',
        component: () => import('@/views/DashboardECommerce.vue'),
        props: {
          scope: 'fengshui.dashboard'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Feng-Shui'
            },
            {
              title: 'Dashboard',
              active: true
            }
          ],
          pageTitle: 'Feng-Shui Dashboard'
        }
      },
      {
        path: 'companies',
        name: 'fengshui.companies',
        component: () => import('@/components/archistar/table/table.vue'),
        props: {
          scope: 'fengshui.companies'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Feng-Shui'
            },
            {
              title: 'Companies',
              active: true
            }
          ],
          pageTitle: 'Feng-Shui Companies'
        }
      },
      {
        path: 'users',
        name: 'fengshui.users',
        component: () => import('@/components/archistar/table/table.vue'),
        props: {
          scope: 'fengshui.users'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Feng-Shui'
            },
            {
              title: 'Users',
              active: true
            }
          ],
          pageTitle: 'Feng-Shui Users'
        }
      }
    ]
  },
  {
    path: '/reports',
    component: () => import('@/layouts/main/archistar/Main.vue'),
    children: [
      {
        path: 'reports',
        name: 'archistar.reports',
        component: () => import('@/components/archistar/table/table.vue'),
        props: {
          scope: 'archistar.reports'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Archistar'
            },
            {
              title: 'Reports',
              active: true
            }
          ],
          pageTitle: 'Archistar DDD Reports',
          rules: [
            {
              resource: 'dataDashboard',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'detailedSubscriptionReport',
        name: 'reports-detailedSubscriptionReport',
        component: () => import('@/views/pages/archistar/acv.vue'),
        props: {
          scope: 'reports.getDetailedSubscriptionsReport'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Reports'
            },
            {
              title: 'Detailed Subscription Report',
              active: true
            }
          ],
          pageTitle: 'Detailed Subscription Report',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'acv',
        name: 'reports-acv',
        component: () => import('@/views/pages/archistar/acv.vue'),
        props: {
          scope: 'reports.acv'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Reports'
            },
            {
              title: 'Master ACV',
              active: true
            }
          ],
          pageTitle: 'Master ACV List',
          rules: [
            {
              resource: 'sales reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'acv_old',
        name: 'reports-acv-old',
        component: () => import('@/views/pages/archistar/acv.vue'),
        props: {
          scope: 'reports.acv_old'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Reports'
            },
            {
              title: 'Old Master ACV',
              active: true
            }
          ],
          pageTitle: 'Old Master ACV List',
          rules: [
            {
              resource: 'super admin',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'newsales',
        name: 'reports-newsales',
        component: () => import('@/components/archistar/table/table_withDateRange.vue'),
        props: {
          scope: 'reports.newSales'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Reports'
            },
            {
              title: 'New Sales',
              active: true
            }
          ],
          pageTitle: 'New Sales Report',
          rules: [
            {
              resource: 'super admin',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'recentrenewals',
        name: 'reports-recentrenewals',
        component: () => import('@/components/archistar/table/table_withDateRange.vue'),
        props: {
          scope: 'reports.recentRenewals'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Reports'
            },
            {
              title: 'Recent Renewals',
              active: true
            }
          ],
          pageTitle: 'Recent Renewals Report',
          rules: [
            {
              resource: 'super admin',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'expiressoon',
        name: 'reports-expiressoon',
        component: () => import('@/components/archistar/table/table_withDateRange.vue'),
        props: {
          scope: 'reports.expiresSoon'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Reports'
            },
            {
              title: 'Expires Soon',
              active: true
            }
          ],
          pageTitle: 'Expires Soon Report',
          rules: [
            {
              resource: 'super admin',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'recentcancellations',
        name: 'reports-recentcancellations',
        component: () => import('@/components/archistar/table/table_withDateRange.vue'),
        props: {
          scope: 'reports.recentCancellations'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Reports'
            },
            {
              title: 'Recent Cancellations',
              active: true
            }
          ],
          pageTitle: 'Recent Cancellations Report',
          rules: [
            {
              resource: 'super admin',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'appVersionChangeFeedback',
        name: 'reports-appVersionChangeFeedback',
        component: () => import('@/components/archistar/table/table.vue'),
        props: {
          scope: 'reports.appVersionChangeFeedback'
        },
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Reports'
            },
            {
              title: 'App Version Change Feedback',
              active: true
            }
          ],
          pageTitle: 'App Version Change Feedback',
          rules: [
            {
              resource: 'system users',
              rule: 'read'
            }
          ]
        }
      }
    ]
  }
];

routes = [
  ...routes,
  ...cartRoutes,
  ...refactoredRoutes,
  ...adminRoutes,
  ...subscriptionRoutes,
  ...financeRoutes,
  ...academyRoutes,
  ...archistarRoutes,
  ...selfServeRoutes,
  ...directMailRoutes
];

if (process.env.VUE_APP_ADD_BILLING_CLEANUP_TABLES) {
  routes = [
    ...routes,
    {
      path: '/billingCleanup',
      component: () => import('@/layouts/main/archistar/Main.vue'),
      children: [
        {
          path: 'getStripePinchData',
          name: 'billingCleanup-getStripePinchData',
          component: () => import('@/components/archistar/table/table.vue'),
          props: {
            scope: 'billingCleanup.getStripePinchData'
          },
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/'
              },
              {
                title: 'Billing Cleanup'
              },
              {
                title: 'Stripe & Pinch Data',
                active: true
              }
            ],
            pageTitle: 'Stripe & Pinch Data',
            rules: [
              {
                resource: 'super admin',
                rule: 'read'
              }
            ]
          }
        },
        {
          path: 'stripeCustomer',
          name: 'billingCleanup-stripeCustomer',
          component: () => import('@/components/archistar/table/table.vue'),
          props: {
            scope: 'billingCleanup.stripeCustomer'
          },
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/'
              },
              {
                title: 'Billing Cleanup'
              },
              {
                title: 'Stripe Customer',
                active: true
              }
            ],
            pageTitle: 'Stripe Customer',
            rules: [
              {
                resource: 'super admin',
                rule: 'read'
              }
            ]
          }
        },
        {
          path: 'pinchCustomer',
          name: 'billingCleanup-pinchCustomer',
          component: () => import('@/components/archistar/table/table.vue'),
          props: {
            scope: 'billingCleanup.pinchCustomer'
          },
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/'
              },
              {
                title: 'Billing Cleanup'
              },
              {
                title: 'Pinch Payers',
                active: true
              }
            ],
            pageTitle: 'Pinch Payers',
            rules: [
              {
                resource: 'super admin',
                rule: 'read'
              }
            ]
          }
        },
        {
          path: 'getPendingSetSubscriptionsCleanup',
          name: 'billingCleanup-getPendingSetSubscriptionsCleanup',
          component: () => import('@/components/archistar/table/table.vue'),
          props: {
            scope: 'billingCleanup.getPendingSetSubscriptionsCleanup'
          },
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/'
              },
              {
                title: 'Billing Cleanup'
              },
              {
                title: 'Pending Set Subscriptions',
                active: true
              }
            ],
            pageTitle: 'Pending Set Subscriptions',
            rules: [
              {
                resource: 'super admin',
                rule: 'read'
              }
            ]
          }
        },
        {
          path: 'getPendingCronActiveSubscriptionsCleanup',
          name: 'billingCleanup-getPendingCronActiveSubscriptionsCleanup',
          component: () => import('@/components/archistar/table/table.vue'),
          props: {
            scope: 'billingCleanup.getPendingCronActiveSubscriptionsCleanup'
          },
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/'
              },
              {
                title: 'Billing Cleanup'
              },
              {
                title: 'Pending Cron Active Subscriptions',
                active: true
              }
            ],
            pageTitle: 'Pending Cron Active Subscriptions',
            rules: [
              {
                resource: 'super admin',
                rule: 'read'
              }
            ]
          }
        },
        {
          path: 'getCronActiveSubscriptionsCleanup',
          name: 'billingCleanup-getCronActiveSubscriptionsCleanup',
          component: () => import('@/components/archistar/table/table.vue'),
          props: {
            scope: 'billingCleanup.getCronActiveSubscriptionsCleanup'
          },
          meta: {
            breadcrumb: [
              {
                title: 'Home',
                url: '/'
              },
              {
                title: 'Billing Cleanup'
              },
              {
                title: 'Cron Active Subscriptions',
                active: true
              }
            ],
            pageTitle: 'Cron Active Subscriptions',
            rules: [
              {
                resource: 'super admin',
                rule: 'read'
              }
            ]
          }
        }
      ]
    }
  ];
}

export default [...routes, ...Helper.GetAuthRoutes()];
